import React from 'react';
import { useLinesContext } from '../../contexts/Lines';
import LoadingBackdrop from '../LoadingBackdrop';
import Content from './Content';
import SubmitApplicationButton from './SubmitApplicationButton';
import GeneratedLinesForYouAlert from './Alerts/GeneratedLinesForYouAlert';
import LineTutorialVideo from './LineTutorialVideo';
import { is8DataApp } from '../../utils';

export default function Layout({
  loadingColor,
  loadingText,
  loadingTextColor,
  loadingSpinnerColor,
}) {
  const { loading, lines } = useLinesContext();
  const is8Data = is8DataApp();

  return (
    <React.Fragment>
      <div>
        <LoadingBackdrop
          open={loading}
          message={loadingText}
          messageColor={loadingTextColor}
          backdropColor={loadingColor}
          spinnerColor={loadingSpinnerColor}
        />
        {lines !== null && <Content />}
        <GeneratedLinesForYouAlert />
        {!is8Data && <SubmitApplicationButton />}
      </div>
      <LineTutorialVideo />
    </React.Fragment>
  );
}
